import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import LikeComplete from '../assets/likeComplete.svg';
import Config from '../../../../Config';
import Property from '@episerver/spa-core/Components/Property';

const CompleteStep = ({data, context, isFromLeadPage}) => {
  const [buttonMsg, setButtonMsg] = useState('');
  let imgLikeCompleteSrc = LikeComplete;

  useEffect(() => {
    window.scrollTo(0, 0);
    setButtonMsg(data?.buttonCompleteText?.value);
  }, []);

  function backHomePage() {
    context.navigateTo(Config.basePath);
  }
  let textCompleted = isFromLeadPage ? (
    <Property className='complete-step__message' context={context} iContent={data} field='completeLeadProgressText' />
  ) : (
    <Property className='complete-step__message' context={context} iContent={data} field='completeProgressText' />
  );
  return (
    <Container>
      <Row className='justify-content-center'>
        <Col>
          <div className='complete-step__title'>
            <Image src={imgLikeCompleteSrc} alt='לייק' />
          </div>
          {textCompleted}
        </Col>
      </Row>
      <Row className='justify-content-center'>
        <div className='complete-step__button'>
          <BtnSubmit text={buttonMsg} onclick={() => backHomePage()} />
        </div>
      </Row>
    </Container>
  );
};
export default CompleteStep;
